module.exports = __webpack_public_path__ + "img/6d9d2c9ae95bc41e90d3b84ffdb9a457.png";